module.exports = __webpack_public_path__ + "img/Saba Island.98d7f4d6.svg";